module.exports = __webpack_public_path__ + "img/empilhadeiras_CARD_SMALL.96488105.jpg";